import React from 'react';
import { Reveal } from '../Reveal';
import { Eyebrow } from './SectionBand';
const groups = [{
  title: 'Get in the room',
  line: 'Podcasts, interviews, speaking, and content that opens doors.'
}, {
  title: 'Keep the conversation going',
  line: 'Follow-up, clearer calls to action, and stronger sales conversations.'
}, {
  title: 'Connect the right readers to the right work',
  line: 'Coaching, consulting, speaking, training, workshops, courses, certification, communities, and more.',
  emphasize: true
}];

/**
 * Simplified editorial business-payoff — three forms of author leverage.
 * Resting state is fully opaque for contrast (no faded/disabled look).
 */
export function BusinessPayoffV2() {
  return <section className="bg-[#1a2838] px-6 pb-12 pt-10 text-[#faf8f5] md:px-10 md:pb-14 md:pt-12" data-id="element-647" data-mp="1lcgj3f31gkau">
      <div className="mx-auto max-w-5xl" data-id="element-648" data-mp="e0zlmn42h59b">
        <div className="max-w-3xl" data-id="element-649" data-mp="dxtxba39i7en">
          <Reveal data-id="element-650" data-mp="9xthpm4ffq60">
            <Eyebrow data-id="element-651" data-mp="9x9z036ycxqx">Author leverage</Eyebrow>
            <h2 className="mt-3 font-serif text-3xl leading-[1.12] text-[#faf8f5] md:text-5xl" data-id="element-652" data-mp="a0pidi7nssy5">
              <span className="block" data-id="element-653" data-mp="2fkzwk6bbyduj">Your book creates authority.</span>
              <span className="mt-1.5 block italic text-[#a8c4bb]" data-id="element-654" data-mp="2kldvmyuyedgf">
                A Reader-to-Revenue path turns it into leverage.
              </span>
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-655" data-mp="2amyd3k9zscij">
              Without that path, even interested readers can finish the book and
              disappear. You never learn what landed, what they need, or where
              they fit in the work behind your book.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-[#faf8f5]/95" data-id="element-656" data-mp="1mz6q9mqtsh30">
              We build the path that turns reader interest into action, useful
              context and better-fit business opportunity.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.05} data-id="element-657" data-mp="1iwk5g5sknwfb">
          <p className="mt-10 text-xs font-semibold uppercase tracking-[0.22em] text-[#faf8f5]/55" data-id="element-658" data-mp="1iwtmv4zjwv9e">
            What author leverage looks like:
          </p>
          <div className="mt-5 divide-y divide-white/15 border-y border-white/15" data-id="element-659" data-mp="3knkddnc49k8k">
            {groups.map(g => <div key={g.title} className={`py-5 md:grid md:grid-cols-[7.5rem_minmax(0,14rem)_1fr] md:items-baseline md:gap-x-8 md:py-6 ${g.emphasize ? 'md:py-7' : ''}`} data-id="element-660" data-mp="3ft6bd22y8eux">
                <p className={`text-[0.78rem] font-semibold uppercase tracking-[0.2em] ${g.emphasize ? 'text-[#d4a574]' : 'text-[#a8c4bb]'}`} data-id="element-661" data-mp="36w5sfaynf8yv">
                  Leverage to
                </p>
                <h3 className={`mt-2 font-serif leading-snug md:mt-0 ${g.emphasize ? 'text-2xl text-[#d4a574] md:text-3xl' : 'text-xl text-[#faf8f5] md:text-2xl'}`} data-id="element-662" data-mp="2gmerzwtc7sg">
                  {g.title}
                </h3>
                <p className="mt-2 text-base leading-relaxed text-[#faf8f5]/80 md:mt-0 md:text-lg" data-id="element-663" data-mp="3pmwxi0blsd7g">
                  {g.line}
                </p>
              </div>)}
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-664" data-mp="2e4cejq62azku">
          <p className="mx-auto mt-10 max-w-3xl text-center font-serif text-2xl leading-snug text-[#faf8f5] md:text-3xl" data-id="element-665" data-mp="tnv1nbr9prqm">
            That is the opportunity.
            <br data-id="element-666" data-mp="ymxwy4hg4jle" />
            <span className="italic text-[#a8c4bb]" data-id="element-667" data-mp="ykbps5ygw63p">
              But it is probably not what is happening now.
            </span>
          </p>
        </Reveal>
      </div>
    </section>;
}